import script from "./InProgress.tab.vue?vue&type=script&setup=true&lang=js"
export * from "./InProgress.tab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPullToRefresh from 'quasar/src/components/pull-to-refresh/QPullToRefresh.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPullToRefresh,QPage,QPageSticky,QBtn});
